import React, { FC } from 'react'

import { InlineSwitch } from '@new/__global/components/Filters/FiltersVariations/InlineSwitch'
import { FilterRenderingComponentProps } from '@new/__global/components/FiltersFramework'

export const RatesFilter: FC<FilterRenderingComponentProps<boolean>> = ({
  activeValue = false,
  onChange,
}) => <InlineSwitch title="Nightly Rate" initialValue={activeValue} onChange={onChange} />
